module.exports = __webpack_public_path__ + "static/media/ic_given_flexibility_red.07c68c7d.svg";